<div class="loader-container" *ngIf="showLoader || isLoader">
  <div class="loader-wrapper">
    <div class="loader"></div>
  </div>
</div>
